import React, { useEffect } from 'react';
import getLogger from '@ignitesales/logger-es';
import classNames from 'classnames';
import { ProductPagePropTypes } from '../../utils';
import {completeRemoteSession, useDispatch} from '../../state';
import {useNeuroMessages} from '../../components/index.mjs';

const logger = getLogger({ component: 'RemoteSummaryPage' });

const RemoteSummaryPage = (props) => {
  logger.debug('Remote summary page props', props);
  const appDispatch = useDispatch();
  const messageContext = useNeuroMessages();
  const { componentClass: defaultComponentClasses } = props;
  const classes = classNames('remoteSummaryPage', defaultComponentClasses);

  const getMessagesForCompleteSession = () => {
    //TODO: document how to format remote banker session message
    const msgId = 'remoteSession.onCompleteMsg';
    const grabMessage = key => messageContext.hasMessage(`${msgId}.${key}`) ? messageContext.formatIntlMessage({id: `${msgId}.${key}`}) : '';
    return {
      message: grabMessage('message'),
      subject: grabMessage('subject')
    };
  };

  useEffect(() => {
    appDispatch(completeRemoteSession(getMessagesForCompleteSession()));
  }, []);

  return (
    <div className={classes}>
      <h1>Need to implement the Remote Summary Page content</h1>
    </div>
  );
};
RemoteSummaryPage.propTypes = ProductPagePropTypes;

export default RemoteSummaryPage;
